// Module-level singleton — holds the preprocessed image between the parse
// mutation and the review screen. Cleared after the review screen reads it
// so memory is not held longer than needed.
let _image: string | null = null;

export const ocrPreviewStore = {
  set: (img: string | null) => { _image = img; },
  get: (): string | null => _image,
  consume: (): string | null => { const v = _image; _image = null; return v; },
};
